import Layout from '../../components/Layout/Main';
import Content from '../../components/Pages/MarketRates';
import { displayName } from '../../config';

const MarketRates = (): JSX.Element => {
  document.title = `${displayName}: Markets`;

  return (
    <Layout>
      <Content />
    </Layout>
  );
};

export default MarketRates;
